
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e480534c87254554f42ae644e6b07d72.jpg')`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/90 via-primary/70 to-primary-dark/85"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1440px] mx-auto px-8 w-full">
        <div className="grid grid-cols-12 gap-8 items-center">
          {/* Left Content */}
          <div className="col-span-7">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              {/* Tag */}
              <div className="inline-flex items-center gap-2 px-4 py-2 border-2 border-white/40 rounded-full mb-6">
                <span className="text-white text-sm font-medium whitespace-nowrap">
                  国家级政策 · 广州试点
                </span>
              </div>

              {/* Main Title */}
              <h1 className="text-7xl font-bold text-white mb-6 leading-tight">
                广州市场采购贸易<br />
                <span className="text-accent">1039</span>数字化入口
              </h1>

              {/* Subtitle */}
              <p className="text-2xl text-neutral-200 font-light mb-12 leading-relaxed">
                白云天健 · 合规出口 · 一站式系统
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col gap-5">
                <Link
                  to="/test"
                  className="w-[280px] h-16 bg-gradient-to-r from-accent to-accent-dark text-primary text-lg font-bold rounded-full flex items-center justify-center gap-3 hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer"
                >
                  测试我是否适合1039
                  <i className="ri-arrow-right-line text-xl"></i>
                </Link>
                <Link
                  to="/policy"
                  className="w-[280px] h-16 border-2 border-white text-white text-lg font-bold rounded-full flex items-center justify-center gap-3 hover:bg-white hover:text-primary transition-all duration-300 cursor-pointer"
                >
                  了解政策
                  <i className="ri-book-open-line text-xl"></i>
                </Link>
              </div>
            </motion.div>
          </div>

          {/* Right Stats */}
          <div className="col-span-5 flex justify-end">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20"
            >
              <div className="grid grid-cols-1 gap-8">
                <div className="text-center">
                  <div className="text-5xl font-bold text-accent mb-2">16</div>
                  <div className="text-white text-sm font-medium">个市场试点</div>
                </div>
                <div className="h-px bg-white/20"></div>
                <div className="text-center">
                  <div className="text-5xl font-bold text-accent mb-2">5000+</div>
                  <div className="text-white text-sm font-medium">服务企业</div>
                </div>
                <div className="h-px bg-white/20"></div>
                <div className="text-center">
                  <div className="text-5xl font-bold text-accent mb-2">100亿+</div>
                  <div className="text-white text-sm font-medium">交易额（元）</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-12 left-1/2 transform -translate-x-1/2"
      >
        <div className="flex flex-col items-center gap-2 cursor-pointer">
          <span className="text-white text-sm font-medium whitespace-nowrap">向下滚动了解更多</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          >
            <i className="ri-arrow-down-line text-white text-2xl"></i>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
